function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#USDU_svg__clip0_1_129)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 29.508c8.288 0 15-6.444 15-14.4S23.288.708 15 .708c-8.287 0-15 6.444-15 14.4s6.713 14.4 15 14.4z",
  fill: "#0D7C67"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.938 14.028v1.236H21.7v.528h2.238v1.236H21.7c-.075 3.264-3.025 5.892-6.4 5.892-3.4 0-6.375-2.604-6.412-5.892h-2.25v-1.236h2.237v-.528H6.638v-1.236h2.237v-1.956c0-1.308-1.362-1.572-1.862-1.572v-.612h3.45v7.068c0 2.988 2.825 4.44 4.825 4.44s4.85-1.836 4.85-4.38V9.888h3.387v.612c-1.225 0-1.837.924-1.837 1.5v2.016c.012.012 2.25.012 2.25.012zm-4.513 2.532c0 1.536-1.087 4.224-4.137 4.224s-4.163-2.628-4.163-4.224V9.888h3.613v.648c-.338 0-1.9.06-1.9 1.632 0 0-.025 2.448-.025 4.332 0 2.064 1.387 2.52 2.325 2.52.925 0 2.525-.372 2.525-2.46v-4.464c0-.78-.475-1.56-1.85-1.56v-.648h3.612v6.672z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "USDU_svg__clip0_1_129"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgUsdu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "a3b1553504eac364924f64c7d039629e.svg";
export { SvgUsdu as ReactComponent };